(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cf-artwork-ring"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cf-motion-deck')) {
  customElements.define('cf-motion-deck', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.abort = new AbortController();
      this.track = this.querySelector('.cf-track');
      this.stage = this.querySelector('.cf-stage');
      this.originals = [...this.querySelectorAll('.cf-item')];
      this.items = [...this.originals];
      this.ring = this.dataset.mode === 'ring';
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.angle = 0; this.velocity = 0; this.active = -1; this.frame = 0;
      this.visible = false;
      this.hovered = false; this.focused = false; this.lastTime = 0;
      this.prev = this.querySelector('[data-prev]');
      this.next = this.querySelector('[data-next]');
      this.count = this.querySelector('[data-count]');
      this.status = this.querySelector('[data-status]');
      if (!this.items.length) {this.querySelector('.cf-controls').hidden = true; return;}
      if (this.ring && this.items.length > 1) {
        const slots = Math.max(this.items.length, Math.min(24, Number(this.dataset.slots) || 0));
        for (let n = this.items.length; n < slots; n++) {
          const clone = this.originals[n % this.originals.length].cloneNode(true);
          clone.removeAttribute('data-shopify-editor-block');
          clone.setAttribute('aria-hidden', 'true'); clone.dataset.clone = 'true';
          clone.querySelectorAll('a,button').forEach(el => el.tabIndex = -1);
          this.track.append(clone); this.items.push(clone);
        }
      }
      this.classList.add('cf-ready');
      this.listen(this.prev,'click',()=>this.step(-1));
      this.listen(this.next,'click',()=>this.step(1));
      this.listen(this.stage,'keydown',e=>{
        if (e.target.matches('input,textarea,select')) return;
        if (e.key==='ArrowLeft'||e.key==='ArrowRight') {e.preventDefault();this.step(e.key==='ArrowRight'?1:-1);}
        if(e.key==='Home'||e.key==='End'){e.preventDefault();this.go(e.key==='Home'?0:this.items.length-1);}
      });
      this.listen(this.track,'scroll',()=>this.wake(),{passive:true});
      this.listen(this.track,'dragstart',e=>e.preventDefault());
      this.listen(this.track,'pointerdown',e=>this.down(e));
      this.listen(window,'pointermove',e=>this.move(e),{passive:false});
      this.listen(window,'pointerup',e=>this.up(e));
      this.listen(window,'pointercancel',e=>this.up(e));
      this.listen(this.track,'click',e=>{if(this.suppressClick){e.preventDefault();e.stopPropagation();this.suppressClick=false;}},{capture:true});
      this.listen(this,'pointerenter',e=>{if(e.pointerType==='mouse'){this.hovered=true;this.syncVideos();}});
      this.listen(this,'pointerleave',()=>{this.hovered=false;this.syncVideos();this.wake();});
      this.listen(this,'focusin',e=>{
        this.focused=true;
        const item=e.target.closest('.cf-item');
        if(item && !item.dataset.clone && e.target.matches('a,button')) this.go(this.items.indexOf(item),false);
        this.syncVideos();
      });
      this.listen(this,'focusout',()=>{queueMicrotask(()=>{this.focused=this.contains(document.activeElement);this.syncVideos();this.wake();});});
      this.listen(document,'visibilitychange',()=>{this.syncVideos();this.wake();});
      this.listen(this.motion,'change',()=>{this.velocity=0;this.target=null;this.syncVideos();this.wake();});
      this.listen(document,'shopify:block:select',e=>{
        if(this.contains(e.target)){const item=e.target.closest('.cf-item');if(item){this.go(this.items.indexOf(item),false);}}
      });
      this.resize = new ResizeObserver(()=>{this.measure();this.wake();});this.resize.observe(this.stage);
      this.observer = new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;this.syncVideos();this.wake();},{threshold:0.05});
      this.observer.observe(this);
      this.videoObserver = new IntersectionObserver(entries=>{entries.forEach(e=>{e.target.dataset.inView=e.isIntersecting?'true':'false';});this.syncVideos();},{root:null,threshold:.15});
      this.querySelectorAll('video').forEach(v=>this.videoObserver.observe(v));
      this.measure();this.render();if(!this.ring)this.setStartPosition();this.wake();
    }
    listen(target,type,fn,options={}) {target?.addEventListener(type,fn,{...options,signal:this.abort.signal});}
    measure() {
      const css=getComputedStyle(this);this.cardWidth=parseFloat(css.getPropertyValue('--cf-card-w'))||280;
      this.perspective=parseFloat(css.getPropertyValue('--cf-perspective'))||1500;
      const mobile=this.stage.clientWidth<750;
      this.cameraDistance=Math.max(0,Number(mobile?(this.dataset.mobileDistance??280):(this.dataset.cameraDistance??640)));
      this.radius=Number(mobile?this.dataset.mobileRadius:this.dataset.radius)||400;
      this.ringVisualScale=mobile?Math.max(.5,Math.min(1.5,Number(this.dataset.mobileRingScale||100)/100)):1;
      this.tilt=Number(this.dataset.tilt||8)*Math.PI/180;
      this.depth=Number(this.dataset.depth||12);
      this.fade=Number(this.dataset.fade??20)/100;this.fadeStart=Number(this.dataset.fadeStart??55);this.fadeEnd=Math.max(this.fadeStart+1,Number(this.dataset.fadeEnd??150));
      this.speed=Number(this.dataset.speed||4);
      this.sensitivity=Number(this.dataset.sensitivity||35)/100;
      this.gap=parseFloat(css.getPropertyValue('--cf-gap'))||20;
      if(this.ring){
        const safeRadius=Math.min(this.radius,this.perspective*.48);
        const available=Math.max(120,this.stage.clientWidth-30);
        this.radius=mobile?safeRadius:Math.min(safeRadius,available/2.35);
        const largestCard=Math.max(this.cardWidth,...this.items.map(item=>item.offsetWidth));
        const fitRadius=mobile?Math.min(this.radius,available/2.35):this.radius;
        const desiredDiameter=2*fitRadius+largestCard;
        this.ringScale=Math.min(1,available/desiredDiameter);
        const widths=this.items.map(item=>item.offsetWidth||this.cardWidth);
        const arcs=()=>widths.map(width=>2*Math.atan(width*this.ringScale/(2*this.radius)));
        let spans=arcs();
        for(let n=0;n<30&&spans.reduce((a,b)=>a+b,0)>Math.PI*1.9;n++){this.ringScale*=.95;spans=arcs();}
        const gap=(Math.PI*2-spans.reduce((a,b)=>a+b,0))/this.items.length;
        this.slotAngles=[0];for(let n=1;n<this.items.length;n++)this.slotAngles[n]=this.slotAngles[n-1]+(spans[n-1]/2+gap+spans[n]/2)*180/Math.PI;
        this.arcSpans=spans;this.arcGap=gap;
      }
    }
    auto() {return this.dataset.autoplay === 'true'&&!this.motion.matches&&!this.hovered&&!this.focused&&!this.pointer&&this.visible&&!document.hidden&&this.items.length>1;}
    syncVideos() {
      this.querySelectorAll('video').forEach(v=>{
        const item=v.closest('.cf-item');
        const front=!this.ring||!item||Number(item.dataset.front||0)>0;
        if(this.visible&&!document.hidden&&!this.motion.matches&&v.dataset.inView==='true'&&front){v.play().catch(()=>{});}else v.pause();
      });
    }
    wake() {if(!this.frame){this.lastTime=0;this.frame=requestAnimationFrame(t=>this.tick(t));}}
    tick(t) {
      this.frame=0;if(!this.isConnected)return;
      const dt=this.lastTime?Math.min(32,t-this.lastTime):16;this.lastTime=t;
      let moving=false;
      if(this.visible&&!document.hidden){
        if(this.ring){
          if(this.target!=null){const diff=this.target-this.angle;this.angle+=diff*(this.motion.matches?1:1-Math.exp(-dt/100));moving=Math.abs(diff)>.05;if(!moving){this.angle=this.target;this.target=null;}}
          else if(!this.pointer&&Math.abs(this.velocity)>.002&&!this.motion.matches){this.angle+=this.velocity*dt;this.velocity*=Math.pow(.93,dt/16);moving=true;}
          else if(this.auto()){this.angle-=this.speed*dt/1000;moving=true;}
        } else if(this.auto()) {
          this.autoElapsed=(this.autoElapsed||0)+dt;
          if(this.autoElapsed>Number(this.dataset.interval||6)*1000){this.autoElapsed=0;this.go((this.active+1)%this.items.length,false);}
          moving=true;
        }
      }
      this.render();if(moving)this.frame=requestAnimationFrame(time=>this.tick(time));
    }
    render() {
      if(!this.items.length)return;
      let active=0;
      if(this.ring){
        let best=-Infinity;
        this.items.forEach((item,i)=>{
          const deg=this.angle+(this.slotAngles?.[i]??i*360/this.items.length);
          const a=deg*Math.PI/180,c=Math.cos(a),s=Math.sin(a);
          const x=s*this.radius*this.ringVisualScale,y=c*this.radius*Math.sin(this.tilt)*this.ringVisualScale,z=c*this.radius*Math.cos(this.tilt)*this.ringVisualScale;
          item.style.transform=`translate3d(${x}px,${y}px,${z-this.cameraDistance}px) rotateX(${-this.tilt}rad) rotateY(${deg}deg) scale(${this.ringScale*this.ringVisualScale})`;
          const distance=Math.acos(Math.max(-1,Math.min(1,c)))*180/Math.PI;const fadeProgress=Math.max(0,Math.min(1,(distance-this.fadeStart)/(this.fadeEnd-this.fadeStart)));item.style.opacity=String(1-fadeProgress*fadeProgress*(3-2*fadeProgress)*this.fade);
          item.style.zIndex=String(Math.round(z+this.radius+1));item.dataset.front=String(c);
          if(c>best){best=c;active=i;}
        });
      } else {
        const center=this.track.scrollLeft+this.track.clientWidth/2;
        let best=Infinity;
        this.items.forEach((item,i)=>{
          const distance=(item.offsetLeft+item.offsetWidth/2-center)/(this.cardWidth+this.gap);
          if(Math.abs(distance)<best){best=Math.abs(distance);active=i;}
          const d=Math.max(-1.6,Math.min(1.6,distance));
          const card=item.querySelector('.cf-card');
          card.style.transform=this.motion.matches?'none':`rotateY(${-d*this.depth}deg) scale(${1-Math.min(Math.abs(d),1)*Number(this.dataset.shrink||6)/100})`;
        });
        this.prev.disabled=active===0;this.next.disabled=active===this.items.length-1;
      }
      if(active!==this.active){
        this.active=active;this.items.forEach((item,i)=>{item.classList.toggle('is-active',i===active);});
        this.count.textContent=`${active%this.originals.length+1} / ${this.originals.length}`;
        this.syncVideos();
      }
    }
    announce(i){const item=this.items[i];const title=item?.querySelector('.cf-title')?.textContent.trim()||'';this.status.textContent=`${i%this.originals.length+1} / ${this.originals.length}: ${title}`;}
    setStartPosition() {
      if(this.ring||!this.items.length)return;
      const position=this.dataset.startPosition||'center';
      if(position==='center') {
        const first=this.items[0],last=this.items[this.items.length-1];
        this.track.style.scrollSnapType='none';
        this.track.scrollLeft=(first.offsetLeft+last.offsetLeft+last.offsetWidth)/2-this.track.clientWidth/2;
        this.render();
      } else {
        const upcoming=this.items.findIndex(item=>item.dataset.upcoming==='true');
        const index=position==='upcoming'&&upcoming>=0?upcoming:0;
        this.track.style.scrollSnapType='';
        this.track.scrollLeft=this.items[index].offsetLeft+this.items[index].offsetWidth/2-this.track.clientWidth/2;
        this.render();
      }
    }
    go(i,announce=true) {
      if(!this.ring)this.track.style.scrollSnapType='';
      i=Math.max(0,Math.min(this.items.length-1,i));this.velocity=0;this.autoElapsed=0;
      if(this.ring){
        let goal=-(this.slotAngles?.[i]??i*360/this.items.length);goal+=Math.round((this.angle-goal)/360)*360;
        this.target=goal;if(this.motion.matches){this.angle=goal;this.target=null;}
      } else {const item=this.items[i];this.track.scrollTo({left:item.offsetLeft+item.offsetWidth/2-this.track.clientWidth/2,behavior:this.motion.matches?'instant':'smooth'});}
      if(announce)this.announce(i);this.wake();
    }
    step(direction) {this.go(this.ring?(this.active+direction+this.items.length)%this.items.length:this.active+direction);}
    down(e) {
      if(e.button!==0||e.target.closest('button,input,select,summary,details'))return;
      if(!this.ring&&e.pointerType!=='mouse')return;
      this.pointer={id:e.pointerId,x:e.clientX,y:e.clientY,lastX:e.clientX,lastTime:e.timeStamp,scroll:this.track.scrollLeft,angle:this.angle,moved:false};
      this.target=null;this.velocity=0;this.suppressClick=false;
    }
    move(e) {
      const p=this.pointer;if(!p||p.id!==e.pointerId)return;
      const dx=e.clientX-p.x,dy=e.clientY-p.y;
      if(!p.moved){if(Math.abs(dy)>Math.abs(dx)&&Math.abs(dy)>8){this.pointer=null;return;}if(Math.abs(dx)<6)return;p.moved=true;this.classList.add('cf-dragging');}
      e.preventDefault();
      if(this.ring){this.angle=p.angle+dx*this.sensitivity;this.velocity=(e.clientX-p.lastX)*this.sensitivity/Math.max(8,e.timeStamp-p.lastTime);}
      else this.track.scrollLeft=p.scroll-dx;
      p.lastX=e.clientX;p.lastTime=e.timeStamp;this.wake();
    }
    up(e) {
      const p=this.pointer;if(!p||p.id!==e.pointerId)return;
      this.pointer=null;this.classList.remove('cf-dragging');
      if(p.moved){this.suppressClick=true;if(!this.ring)this.go(this.active);if(e.timeStamp-p.lastTime>100)this.velocity=0;}
      if(this.motion.matches)this.velocity=0;this.wake();
    }
    disconnectedCallback() {
      this.abort?.abort();this.resize?.disconnect();this.observer?.disconnect();this.videoObserver?.disconnect();cancelAnimationFrame(this.frame);
      this.querySelectorAll('[data-clone]').forEach(e=>e.remove());this.ready=false;this.frame=0;
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cf-drop-timeline"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cf-drop-timeline-v4')) {
  customElements.define('cf-drop-timeline-v4', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.abort = new AbortController();
      this.track = this.querySelector('.cf-track');
      this.stage = this.querySelector('.cf-stage');
      this.originals = [...this.querySelectorAll('.cf-item')];
      this.items = [...this.originals];
      this.ring = this.dataset.mode === 'ring';
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.angle = 0; this.velocity = 0; this.active = -1; this.frame = 0;
      this.paused = false; this.visible = false;
      this.hovered = false; this.focused = false; this.lastTime = 0;
      this.prev = this.querySelector('[data-prev]');
      this.next = this.querySelector('[data-next]');
      this.pause = this.querySelector('[data-pause]');
      this.count = this.querySelector('[data-count]');
      this.status = this.querySelector('[data-status]');
      if (!this.items.length) {this.querySelector('.cf-controls').hidden = true; return;}
      if (this.ring && this.items.length > 1) {
        const slots = Math.max(this.items.length, Math.min(24, Number(this.dataset.slots) || 0));
        for (let n = this.items.length; n < slots; n++) {
          const clone = this.originals[n % this.originals.length].cloneNode(true);
          clone.removeAttribute('data-shopify-editor-block');
          clone.setAttribute('aria-hidden', 'true'); clone.dataset.clone = 'true';
          clone.querySelectorAll('a,button').forEach(el => el.tabIndex = -1);
          this.track.append(clone); this.items.push(clone);
        }
      }
      this.classList.add('cf-ready');
      this.items.forEach(item=>{
        item.tabIndex=0;item.dataset.pop='false';item.dataset.baseLabel=item.getAttribute('aria-label')||'Drop card';
        this.listen(item,'keydown',e=>{if(e.target===item&&(e.key==='Enter'||e.key===' ')&&this.popEnabled()){e.preventDefault();this.setPop(this.popItem===item?null:item);}});
        this.listen(item,'pointerenter',e=>{if(e.pointerType==='mouse'&&this.popEnabled()&&!this.pointer&&!this.popDragged){this.hoverPop=item;this.setPop(item);}});
        this.listen(item,'pointerleave',e=>{if(this.pointer&&this.popDragFromPreview)return;if(e.pointerType==='mouse'&&this.hoverPop===item&&!this.pointerInPopArea(item,e)){this.hoverPop=null;this.setPop(null);}});
      });
      this.listen(this.stage,'pointermove',e=>{if(this.pointer&&this.popDragFromPreview)return;if(e.pointerType==='mouse'&&this.hoverPop&&!this.pointerInPopArea(this.hoverPop,e)){this.hoverPop=null;this.setPop(null);}});
      this.listen(this.stage,'pointerleave',e=>{if(this.pointer&&this.popDragFromPreview)return;if(e.pointerType==='mouse'&&this.hoverPop){this.hoverPop=null;this.setPop(null);}});
      this.listen(this,'pointerdown',e=>{this.popStart={x:e.clientX,y:e.clientY};this.popDragged=false;});
      this.listen(this,'pointermove',e=>{if(this.popStart&&Math.hypot(e.clientX-this.popStart.x,e.clientY-this.popStart.y)>8)this.popDragged=true;});
      this.listen(this,'pointerup',()=>{this.popStart=null;setTimeout(()=>{this.popDragged=false;},0);});
      this.listen(this,'pointercancel',()=>{this.popStart=null;this.popDragged=false;});
      this.listen(this,'click',e=>{
        if(this.suppressClick&&this.popDragFromPreview){e.preventDefault();e.stopPropagation();this.suppressClick=false;this.popDragFromPreview=false;return;}
        if(!this.popEnabled()||this.popDragged)return;
        if(e.target.closest('.cf-pop-preview'))return;
        const item=e.target.closest('.cf-item');
        if(!item){this.setPop(null);return;}
        if(e.pointerType==='mouse'&&this.hoverPop===item)return;
        if(this.popItem!==item){e.preventDefault();e.stopPropagation();this.setPop(item);}
        else if(!e.target.closest('a,button,summary,details'))this.setPop(null);
      },{capture:true});
      this.listen(document,'click',e=>{if(!this.contains(e.target))this.setPop(null);});
      this.listen(document,'keydown',e=>{if(e.key==='Escape')this.setPop(null);});

      this.listen(this.prev,'click',()=>this.step(-1));
      this.listen(this.next,'click',()=>this.step(1));
      this.listen(this.pause,'click',()=>{this.paused=!this.paused;this.updatePause();this.syncVideos();this.wake();});
      this.pause.hidden = this.dataset.autoplay !== 'true' && !this.querySelector('video');
      this.listen(this.stage,'keydown',e=>{
        if (e.target.matches('input,textarea,select')) return;
        if (e.key==='ArrowLeft'||e.key==='ArrowRight') {e.preventDefault();this.step(e.key==='ArrowRight'?1:-1);}
        if(e.key==='Home'||e.key==='End'){e.preventDefault();this.go(e.key==='Home'?0:this.items.length-1);}
      });
      this.listen(this.track,'scroll',()=>{if(this.popItem&&!(this.pointer&&this.popDragFromPreview))this.setPop(null);this.classList.remove('cf-pop-animating');this.wake();},{passive:true});
      this.listen(this.track,'dragstart',e=>e.preventDefault());
      this.listen(this.track,'pointerdown',e=>this.down(e));
      this.listen(this.stage,'dragstart',e=>{if(e.target.closest('.cf-pop-preview'))e.preventDefault();});
      this.listen(this.stage,'pointerdown',e=>{if(e.target.closest('.cf-pop-preview'))this.down(e);});
      this.listen(window,'pointermove',e=>this.move(e),{passive:false});
      this.listen(window,'pointerup',e=>this.up(e));
      this.listen(window,'pointercancel',e=>this.up(e));
      this.listen(this.track,'click',e=>{if(this.suppressClick){e.preventDefault();e.stopPropagation();this.suppressClick=false;}},{capture:true});
      this.listen(this,'pointerenter',e=>{if(e.pointerType==='mouse'){this.hovered=true;this.syncVideos();}});
      this.listen(this,'pointerleave',()=>{this.hovered=false;this.syncVideos();this.wake();});
      this.listen(this,'focusin',e=>{
        this.focused=true;
        const item=e.target.closest('.cf-item');
        if(item && !item.dataset.clone && e.target.matches('a,button')) this.go(this.items.indexOf(item),false);
        this.syncVideos();
      });
      this.listen(this,'focusout',()=>{queueMicrotask(()=>{this.focused=this.contains(document.activeElement);this.syncVideos();this.wake();});});
      this.listen(document,'visibilitychange',()=>{this.syncVideos();this.wake();});
      this.listen(this.motion,'change',()=>{this.velocity=0;this.target=null;this.updatePause();this.syncVideos();this.wake();});
      this.listen(document,'shopify:block:select',e=>{
        if(this.contains(e.target)){const item=e.target.closest('.cf-item');if(item){this.paused=true;this.updatePause();this.go(this.items.indexOf(item),false);}}
      });
      this.resize = new ResizeObserver(()=>{this.measure();if(!this.userMoved&&!this.ring)this.setStartPosition();this.wake();});this.resize.observe(this.stage);
      this.observer = new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;this.syncVideos();this.wake();},{threshold:0.05});
      this.observer.observe(this);
      this.videoObserver = new IntersectionObserver(entries=>{entries.forEach(e=>{e.target.dataset.inView=e.isIntersecting?'true':'false';});this.syncVideos();},{root:null,threshold:.15});
      this.querySelectorAll('video').forEach(v=>this.videoObserver.observe(v));
      this.items.forEach(item=>this.resize.observe(item));
      this.listen(this,'load',()=>this.wake(),{capture:true});
      if(document.fonts)document.fonts.ready.then(()=>{if(this.isConnected){this.measure();if(!this.userMoved)this.setStartPosition();this.wake();}});
      this.measure();this.updatePause();this.render();if(!this.ring)this.setStartPosition();this.wake();
    }
    popEnabled(){return this.dataset.curveLayout==='curved'&&(this.stage.clientWidth<750?this.dataset.popEnabled!=='false':this.dataset.desktopPopEnabled!=='false');}
    pointerInPopArea(item,e){
      const inside=rect=>rect&&e.clientX>=rect.left&&e.clientX<=rect.right&&e.clientY>=rect.top&&e.clientY<=rect.bottom;
      return inside(item.getBoundingClientRect())||(this.popItem===item&&inside(this.popPreview?.getBoundingClientRect()));
    }
    setPop(item){
      if(this.popItem===item)return;
      this.popItem=item;
      this.items.forEach(el=>{el.dataset.pop=String(el===item);el.setAttribute('aria-label',el.dataset.baseLabel+(el===item?' — enlarged':''));});
      this.render();this.syncVideos();this.wake();
    }
    updatePopPreview(){
      const item=this.curve&&this.popEnabled()?this.popItem:null;
      if(!item){this.popPreview?.remove();this.popPreview=null;this.popPreviewItem=null;return;}
      const source=item.querySelector('.cf-card');
      if(this.popPreviewItem!==item){
        this.popPreview?.remove();
        const preview=document.createElement('div');preview.className='cf-pop-preview';
        preview.setAttribute('role','group');preview.setAttribute('aria-label',item.dataset.baseLabel+' — enlarged');
        const itemStyle=getComputedStyle(item);
        for(const name of ['--cf-card-pad','--cf-round','--cf-border','--cf-card-bg','--cf-shadow','--cf-glass-opacity','--cf-glass-blur','--cf-glass-color','--cf-shade','--cf-overlay-text']){
          const value=itemStyle.getPropertyValue(name).trim();if(value)preview.style.setProperty(name,value);
        }
        for(let n=0;n<item.style.length;n++){const name=item.style.item(n);if(name.startsWith('--cf-'))preview.style.setProperty(name,item.style.getPropertyValue(name));}
        const card=source.cloneNode(true);card.querySelectorAll('[id]').forEach(el=>el.removeAttribute('id'));
        preview.append(card);
        const footer=document.createElement('div');footer.className='cf-pop-footer';
        if(this.dataset.showIcons!=='false'){
          const sourceMarker=item.querySelector('.cf-node .cf-marker');
          if(sourceMarker){
            const marker=sourceMarker.cloneNode(true),style=getComputedStyle(sourceMarker);
            for(const name of ['width','height','color','backgroundColor','boxShadow'])marker.style[name]=style[name];
            footer.append(marker);
          }
        }
        if(this.dataset.showDates!=='false'){
          const sourceDate=item.querySelector('.cf-date-glass');
          if(sourceDate){
            const dateWrap=document.createElement('div');dateWrap.className='cf-pop-date';
            dateWrap.style.setProperty('--cf-pop-date-size',getComputedStyle(sourceDate.closest('.cf-node')).fontSize);
            dateWrap.append(sourceDate.cloneNode(true));footer.append(dateWrap);
          }
        }
        if(footer.childElementCount)preview.append(footer);
        this.stage.append(preview);this.popPreview=preview;this.popPreviewItem=item;
        preview.querySelectorAll('video').forEach(v=>{v.dataset.inView='true';v.muted=true;});
        this.syncVideos();
      }
      const mobile=this.stage.clientWidth<750;
      const lift=Number(mobile?(this.dataset.popDistance??280):(this.dataset.desktopPopDistance??240));
      const scale=Number(mobile?(this.dataset.popScale??112):(this.dataset.desktopPopScale??116))/100;
      const zoom=scale*(1+Math.max(0,lift)/(4*this.curvePerspective));
      const stage=this.stage.getBoundingClientRect(),rect=source.getBoundingClientRect();
      const width=source.offsetWidth*zoom,height=source.offsetHeight*zoom;
      const clamp=(value,min,max)=>Math.max(min,Math.min(max,value));
      const left=clamp(rect.left-stage.left+(rect.width-width)/2,8,Math.max(8,stage.width-width-8));
      const top=clamp(rect.top-stage.top+(rect.height-height)/2,8,Math.max(8,stage.height-height-8));
      this.popPreview.style.left=`${Math.round(left)}px`;this.popPreview.style.top=`${Math.round(top)}px`;
      this.popPreview.style.width=`${Math.round(width)}px`;this.popPreview.style.height=`${Math.round(height)}px`;
      const card=this.popPreview.querySelector('.cf-card');card.style.width=`${source.offsetWidth}px`;card.style.height=`${source.offsetHeight}px`;card.style.zoom=String(zoom);
      const marker=this.popPreview.querySelector('.cf-pop-footer .cf-marker');if(marker)marker.style.zoom=String(zoom);
      const date=this.popPreview.querySelector('.cf-pop-date .cf-date-glass');if(date)date.style.zoom=String(zoom);
    }
    listen(target,type,fn,options={}) {target?.addEventListener(type,fn,{...options,signal:this.abort.signal});}
    measure() {
      const css=getComputedStyle(this);this.cardWidth=parseFloat(css.getPropertyValue('--cf-card-w'))||280;
      this.perspective=parseFloat(css.getPropertyValue('--cf-perspective'))||1500;
      const mobile=this.stage.clientWidth<750;
      if(!this.popEnabled()){this.popItem=null;this.hoverPop=null;this.items.forEach(el=>{el.dataset.pop='false';el.setAttribute('aria-label',el.dataset.baseLabel);});}
      this.cameraDistance=Math.max(0,Number(mobile?(this.dataset.mobileDistance??280):(this.dataset.cameraDistance??640)));
      this.radius=Number(mobile?this.dataset.mobileRadius:this.dataset.radius)||400;
      this.tilt=Number(this.dataset.tilt||8)*Math.PI/180;
      this.depth=Number(this.dataset.depth||12);
      this.fade=Number(this.dataset.fade??20)/100;this.fadeStart=Number(this.dataset.fadeStart??55);this.fadeEnd=Math.max(this.fadeStart+1,Number(this.dataset.fadeEnd??150));
      this.speed=Number(this.dataset.speed||4);
      this.sensitivity=Number(this.dataset.sensitivity||35)/100;
      this.gap=parseFloat(css.getPropertyValue('--cf-gap'))||0;
      this.curve=this.dataset.curveLayout==='curved';
      const prefix=mobile?'curveMobile':'curve';
      this.curveBend=Number(this.dataset[prefix+'Bend']??24);
      this.curveDistance=Number(this.dataset[prefix+'Distance']??180);
      this.curvePerspective=Number(this.dataset[prefix+'Perspective']??1500);
      this.curveVertical=Number(this.dataset[prefix+'Vertical']??0);
      this.items.forEach(item=>{item.style.perspective=this.curve?this.curvePerspective+'px':'';});
      if(this.ring){
        const safeRadius=Math.min(this.radius,this.perspective*.48);
        const available=Math.max(120,this.stage.clientWidth-30);
        this.radius=Math.min(safeRadius,available/2.35);
        const largestCard=Math.max(this.cardWidth,...this.items.map(item=>item.offsetWidth));
        const desiredDiameter=2*this.radius+largestCard;
        this.ringScale=Math.min(1,available/desiredDiameter);
        const widths=this.items.map(item=>item.offsetWidth||this.cardWidth);
        const arcs=()=>widths.map(width=>2*Math.atan(width*this.ringScale/(2*this.radius)));
        let spans=arcs();
        for(let n=0;n<30&&spans.reduce((a,b)=>a+b,0)>Math.PI*1.9;n++){this.ringScale*=.95;spans=arcs();}
        const gap=(Math.PI*2-spans.reduce((a,b)=>a+b,0))/this.items.length;
        this.slotAngles=[0];for(let n=1;n<this.items.length;n++)this.slotAngles[n]=this.slotAngles[n-1]+(spans[n-1]/2+gap+spans[n]/2)*180/Math.PI;
        this.arcSpans=spans;this.arcGap=gap;
      }
    }
    auto() {return this.dataset.autoplay === 'true'&&!this.paused&&!this.popItem&&!this.motion.matches&&!this.hovered&&!this.focused&&!this.pointer&&this.visible&&!document.hidden&&this.items.length>1;}
    updatePause() {this.pause.setAttribute('aria-pressed',String(this.paused||this.motion.matches));this.pause.setAttribute('aria-label',this.paused||this.motion.matches?this.dataset.playLabel:this.dataset.pauseLabel);}
    syncVideos() {
      this.querySelectorAll('video').forEach(v=>{
        const item=v.closest('.cf-item');
        const front=!this.ring||!item||Number(item.dataset.front||0)>0;
        if(this.visible&&!document.hidden&&!this.motion.matches&&!this.paused&&v.dataset.inView==='true'&&front&&(!item||item!==this.popItem)){v.play().catch(()=>{});}else v.pause();
      });
    }
    wake() {if(!this.frame){this.lastTime=0;this.frame=requestAnimationFrame(t=>this.tick(t));}}
    tick(t) {
      this.frame=0;if(!this.isConnected)return;
      const dt=this.lastTime?Math.min(32,t-this.lastTime):16;this.lastTime=t;
      let moving=false;
      if(this.visible&&!document.hidden){
        if(this.ring){
          if(this.target!=null){const diff=this.target-this.angle;this.angle+=diff*(this.motion.matches?1:1-Math.exp(-dt/100));moving=Math.abs(diff)>.05;if(!moving){this.angle=this.target;this.target=null;}}
          else if(!this.pointer&&Math.abs(this.velocity)>.002&&!this.motion.matches){this.angle+=this.velocity*dt;this.velocity*=Math.pow(.93,dt/16);moving=true;}
          else if(this.auto()){this.angle-=this.speed*dt/1000;moving=true;}
        } else if(this.auto()) {
          this.autoElapsed=(this.autoElapsed||0)+dt;
          if(this.autoElapsed>Number(this.dataset.interval||6)*1000){this.autoElapsed=0;this.go((this.active+1)%this.items.length,false);}
          moving=true;
        }
      }
      this.render();if(performance.now()<(this.popUntil||0))moving=true;else this.classList.remove('cf-pop-animating');if(moving)this.frame=requestAnimationFrame(time=>this.tick(time));
    }
    render() {
      if(!this.items.length)return;
      let active=0;
      if(this.ring){
        let best=-Infinity;
        this.items.forEach((item,i)=>{
          const deg=this.angle+(this.slotAngles?.[i]??i*360/this.items.length);
          const a=deg*Math.PI/180,c=Math.cos(a),s=Math.sin(a);
          const x=s*this.radius,y=c*this.radius*Math.sin(this.tilt),z=c*this.radius*Math.cos(this.tilt);
          item.style.transform=`translate3d(${x}px,${y}px,${z-this.cameraDistance}px) rotateX(${-this.tilt}rad) rotateY(${deg}deg) scale(${this.ringScale})`;
          const distance=Math.acos(Math.max(-1,Math.min(1,c)))*180/Math.PI;const fadeProgress=Math.max(0,Math.min(1,(distance-this.fadeStart)/(this.fadeEnd-this.fadeStart)));item.style.opacity=String(1-fadeProgress*fadeProgress*(3-2*fadeProgress)*this.fade);
          item.style.zIndex=String(Math.round(z+this.radius+1));item.dataset.front=String(c);
          if(c>best){best=c;active=i;}
        });
      } else {
        const center=this.track.scrollLeft+this.track.clientWidth/2;
        let best=Infinity;
        this.items.forEach((item,i)=>{
          const distance=(item.offsetLeft+item.offsetWidth/2-center)/(this.cardWidth+this.gap);
          if(Math.abs(distance)<best){best=Math.abs(distance);active=i;}
          const d=Math.max(-1.6,Math.min(1.6,distance));
          const card=item.querySelector('.cf-card');
          const plane=item.querySelector('.cf-plane');
          if(this.curve&&plane) {
            card.style.transform='none';
            plane.style.translate='';
            const u=item.offsetLeft+item.offsetWidth/2-center;
            const bend=this.curveBend*Math.PI/180;
            const radius=(item.offsetWidth+this.gap)/Math.max(.001,bend);
            const a=Math.max(-1.05,Math.min(1.05,u/radius));
            const sign=this.dataset.curveDirection==='outward'?-1:1;
            const z=Math.min(this.curvePerspective*.3,-this.curveDistance+sign*radius*(1-Math.cos(a)));
            const x=radius*Math.sin(a)+(u-a*radius);
            item.style.perspectiveOrigin=`${item.offsetWidth/2-u}px 50%`;
            plane.style.transform=`translate3d(${x-u}px,${this.curveVertical}px,${z}px) rotateY(${-sign*a}rad)`;
            item.style.zIndex=String(Math.round(z+2000));
          } else {
            if(plane){plane.style.transform='';plane.style.translate=''}item.style.perspectiveOrigin='';
            card.style.transform=this.motion.matches?'none':`rotateY(${-d*this.depth}deg) scale(${1-Math.min(Math.abs(d),1)*Number(this.dataset.shrink||6)/100})`;
          }
        });
        if(this.curve)this.drawCurveLine();
        this.prev.disabled=active===0;this.next.disabled=active===this.items.length-1;
      }
      if(active!==this.active){
        this.active=active;this.items.forEach((item,i)=>{item.classList.toggle('is-active',i===active);});
        this.count.textContent=`${active%this.originals.length+1} / ${this.originals.length}`;
        this.syncVideos();
      }
      this.updatePopPreview();
    }
    keepPoppedCardVisible(plane) {
      const view=this.track.getBoundingClientRect();
      if(!view.width||!view.height)return;
      let x=0,y=0;
      const inset=8;
      for(let pass=0;pass<2;pass++) {
        const rect=plane.getBoundingClientRect();
        if(!rect.width||!rect.height)return;
        const factor=Math.max(.35,Math.min(3,rect.height/(plane.offsetHeight||rect.height)));
        let shiftX=0,shiftY=0;
        if(rect.width>view.width-2*inset)shiftX=(view.left+view.right-rect.left-rect.right)/2;
        else if(rect.left<view.left+inset)shiftX=view.left+inset-rect.left;
        else if(rect.right>view.right-inset)shiftX=view.right-inset-rect.right;
        if(rect.height>view.height-2*inset)shiftY=view.top+inset-rect.top;
        else if(rect.top<view.top+inset)shiftY=view.top+inset-rect.top;
        else if(rect.bottom>view.bottom-inset)shiftY=view.bottom-inset-rect.bottom;
        if(Math.abs(shiftX)<.5&&Math.abs(shiftY)<.5)break;
        x+=shiftX/factor;y+=shiftY/factor;
        plane.style.translate=`${x}px ${y}px`;
      }
    }
    drawCurveLine() {
      if(this.dataset.showLine==='false')return;
      const svg=this.querySelector('.cf-curve-line');if(!svg)return;
      const stage=this.stage.getBoundingClientRect();
      const pts=this.items.map(item=>{const r=item.querySelector('.cf-marker').getBoundingClientRect();return {x:r.left+r.width/2-stage.left,y:r.top+r.height/2-stage.top};});
      let d=pts.length?`M${pts[0].x},${pts[0].y}`:'';
      for(let i=0;i<pts.length-1;i++) {
        const p0=pts[Math.max(0,i-1)],p1=pts[i],p2=pts[i+1],p3=pts[Math.min(pts.length-1,i+2)];
        d+=` C${p1.x+(p2.x-p0.x)/6},${p1.y+(p2.y-p0.y)/6} ${p2.x-(p3.x-p1.x)/6},${p2.y-(p3.y-p1.y)/6} ${p2.x},${p2.y}`;
      }
      svg.querySelector('path').setAttribute('d',d);
    }
    announce(i){const item=this.items[i];const title=item?.querySelector('.cf-title')?.textContent.trim()||'';this.status.textContent=`${i%this.originals.length+1} / ${this.originals.length}: ${title}`;}
    setStartPosition() {
      if(this.ring||!this.items.length)return;
      const position=this.dataset.startPosition||'center';
      if(position==='center') {
        const first=this.items[0],last=this.items[this.items.length-1];
        this.track.style.scrollSnapType='none';
        this.track.scrollLeft=(first.offsetLeft+last.offsetLeft+last.offsetWidth)/2-this.track.clientWidth/2;
        this.render();
      } else {
        const upcoming=this.items.findIndex(item=>item.dataset.upcoming==='true');
        const index=position==='upcoming'&&upcoming>=0?upcoming:0;
        this.track.style.scrollSnapType=this.curve?'none':'';
        this.track.scrollLeft=this.items[index].offsetLeft+this.items[index].offsetWidth/2-this.track.clientWidth/2;
        this.render();
      }
    }
    go(i,announce=true) {
      this.userMoved=true;if(!this.ring)this.track.style.scrollSnapType=this.curve?'none':'';
      i=Math.max(0,Math.min(this.items.length-1,i));this.velocity=0;this.autoElapsed=0;
      if(this.ring){
        let goal=-(this.slotAngles?.[i]??i*360/this.items.length);goal+=Math.round((this.angle-goal)/360)*360;
        this.target=goal;if(this.motion.matches){this.angle=goal;this.target=null;}
      } else {const item=this.items[i];this.track.scrollTo({left:item.offsetLeft+item.offsetWidth/2-this.track.clientWidth/2,behavior:this.motion.matches?'instant':'smooth'});}
      if(announce)this.announce(i);this.wake();
    }
    step(direction) {this.paused=true;this.updatePause();this.go(this.ring?(this.active+direction+this.items.length)%this.items.length:this.active+direction);}
    down(e) {
      if(e.button!==0||e.target.closest('button,input,select,summary,details'))return;
      this.userMoved=true;
      if(!this.ring&&e.pointerType!=='mouse'&&!e.target.closest('.cf-pop-preview'))return;
      this.pointer={id:e.pointerId,x:e.clientX,y:e.clientY,lastX:e.clientX,lastTime:e.timeStamp,scroll:this.track.scrollLeft,angle:this.angle,moved:false};
      this.popDragFromPreview=!!e.target.closest('.cf-pop-preview');
      this.target=null;this.velocity=0;this.suppressClick=false;
    }
    move(e) {
      const p=this.pointer;if(!p||p.id!==e.pointerId)return;
      const dx=e.clientX-p.x,dy=e.clientY-p.y;
      if(!p.moved){if(Math.abs(dy)>Math.abs(dx)&&Math.abs(dy)>8){this.pointer=null;return;}if(Math.abs(dx)<6)return;p.moved=true;this.classList.add('cf-dragging');}
      e.preventDefault();
      if(this.ring){this.angle=p.angle+dx*this.sensitivity;this.velocity=(e.clientX-p.lastX)*this.sensitivity/Math.max(8,e.timeStamp-p.lastTime);}
      else this.track.scrollLeft=p.scroll-dx;
      p.lastX=e.clientX;p.lastTime=e.timeStamp;this.wake();
    }
    up(e) {
      const p=this.pointer;if(!p||p.id!==e.pointerId)return;
      this.pointer=null;this.classList.remove('cf-dragging');
      if(p.moved){this.suppressClick=true;this.paused=true;this.updatePause();if(!this.ring)this.go(this.active);if(e.timeStamp-p.lastTime>100)this.velocity=0;}
      if(this.popDragFromPreview&&p.moved){this.hoverPop=null;this.setPop(null);setTimeout(()=>{this.popDragFromPreview=false;this.suppressClick=false;},0);}else if(!p.moved)this.popDragFromPreview=false;
      if(this.motion.matches)this.velocity=0;this.wake();
    }
    disconnectedCallback() {
      this.popPreview?.remove();this.popPreview=null;this.popPreviewItem=null;
      this.popItem=null;this.popStart=null;this.popUntil=0;this.abort?.abort();this.resize?.disconnect();this.observer?.disconnect();this.videoObserver?.disconnect();cancelAnimationFrame(this.frame);
      this.querySelectorAll('[data-clone]').forEach(e=>e.remove());this.ready=false;this.frame=0;
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
